import { ActionMessages, ACTIONS } from '@root/src/types/common';
import { MemberFront } from './types';

export const memberActionMessages: ActionMessages<MemberFront> = {
  [ACTIONS.CREATE]: {
    successTitleKey: 'api.member.create.successTitle',
    successDescriptionKey: 'api.member.create.successDescription',
    formatMessage: (data: MemberFront) => ({
      memberName: data?.name ?? '',
    }),
  },
  [ACTIONS.UPDATE]: {
    successTitleKey: 'api.member.edit.successTitle',
    successDescriptionKey: 'api.member.edit.successDescription',
    formatMessage: (data: MemberFront) => ({ memberName: data.name ?? '' }),
  },
  [ACTIONS.DELETE]: {
    successTitleKey: 'api.member.delete.successTitle',
    successDescriptionKey: 'api.member.delete.successDescription',
    formatMessage: (data: MemberFront) => ({ memberName: data.name ?? '' }),
  },
};
